import { deleteDoc, doc } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import type { ElasticQueryParams } from '@src/models/interfaces/general/ElasticQueryParams.interface';
import type { ElasticSearchResponse } from '@src/models/interfaces/general/ElasticSearchResponseInterface';
import type { EventElasticSearchIdSource } from '@src/models/interfaces/event.interface';
import elasticQueryClient from '@src/repositories/ElasticQueryClient';

class EventRepository {
  private getDocRef(orgId: string, divId: string, eventId: string) {
    return doc(
      db,
      FSCollections.ORGANIZATIONS,
      orgId,
      FSCollections.DIVISIONS,
      divId,
      FSCollections.EVENTS,
      eventId,
    );
  }

  async delete(orgId: string, divId: string, eventId: string): Promise<void> {
    await deleteDoc(this.getDocRef(orgId, divId, eventId));
  }

  async list<TSource extends EventElasticSearchIdSource = EventElasticSearchIdSource>(
    params: ElasticQueryParams,
  ): Promise<ElasticSearchResponse<TSource> | null> {
    return elasticQueryClient.query(params) as Promise<ElasticSearchResponse<TSource> | null>;
  }
}

export default EventRepository;
